import type { PresentationOptionV2 } from 'paintscout'

/** True when the v2 presentation holds at least one block of `type`, anywhere in pages > sections > blocks. */
export function hasBlockType(presentation: PresentationOptionV2 | null | undefined, type: string): boolean {
  return (presentation?.pages ?? []).some((page) =>
    (page.sections ?? []).some((section) => (section.blocks ?? []).some((block) => block.type === type))
  )
}

/**
 * True when the v2 presentation renders the quote's job photos itself.
 *
 * A document gets a `pictures` block two ways: the user adds one from the v2 catalog (ENG-1402), or
 * v1→v2 conversion carries one over (`convert-pictures.ts`). When it holds none, the estimate
 * document has to render its own Media section — see `showMediaSection` on `Quote` (#22698).
 *
 * This answers "any at all", not "how many". Two `pictures` blocks suppress the Media section once
 * and then render the photos twice; the add-menu does not stop that, same as every other block type.
 */
export function hasPicturesBlock(presentation: PresentationOptionV2 | null | undefined): boolean {
  return hasBlockType(presentation, 'pictures')
}
